import styled from 'styled-components'

import { styleMixins } from '../../../style'
import {
  defaultTextStyle,
  defaultTitleStyle,
} from '../../../style/styleMixins/text'

const { getSpacing } = styleMixins.offset

export const SParent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 500px;
  padding-left: ${getSpacing(3)};
`

export const STitle = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${getSpacing(3)};
  color: ${(p) => p.theme.colors.grey_450};
  ${defaultTitleStyle(2)};
  padding-right: ${getSpacing(1)};
`

export const STextError = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${getSpacing(2)};
  color: ${(p) => p.theme.colors.grey_450};
  ${defaultTextStyle(4)};
  padding-right: ${getSpacing(1)};
`

export const STechSupLink = styled.a`
  color: ${(p) => p.theme.colors.blue_500};
  ${defaultTextStyle(1)};
  text-decoration: none;
  padding-right: ${getSpacing(1)};
`
